import { Button, Field, Link } from "@cluey/cluey-components";
import { FC, FormEvent } from "react";
import LoginEmailRow from "./LoginEmailRow";
import LoginSubmitButton from "./LoginSubmitButton";
import * as PATHS from '../../../../util/pagePath';

export interface LoginPasswordStepProps {
  email: string;
  password: string;
  error: string | false;
  loading: boolean;
  submitLabel: string;
  onSubmit: (e: FormEvent<HTMLFormElement>) => void;
  onPasswordChange: (value: string) => void;
  onChangeEmail: () => void;
  onSignInWithCode: () => void;
  signInWithCodeLoading?: boolean;
}

const LoginPasswordStep: FC<LoginPasswordStepProps> = ({
  email,
  password,
  error,
  loading,
  submitLabel,
  onSubmit,
  onPasswordChange,
  onChangeEmail,
  onSignInWithCode,
  signInWithCodeLoading,
}) => (
  <form onSubmit={onSubmit} className="flex w-full flex-col items-start gap-5">
    <h1 className="max-w-md font-display text-[28px] leading-10 sm:text-[32px] mb-7">Enter your password</h1>
    <LoginEmailRow email={email} onChangeEmail={onChangeEmail} />
    <div className="w-full mb-5">
      <Field
        label="Password"
        name="password"
        value={password}
        onChange={onPasswordChange}
        type="password"
        className="w-full max-w-sm [&_input]:rounded-full"
        error={error}
        disabled={loading}
        />
      <p className="text-sm text-grey-400 mt-1">
        Forgot your password?{' '}
        <Link size="sm" to={PATHS.PATH_HUB_RESET_PASSWORD_REQUEST} className="link">
          Reset password
        </Link>
      </p>
    </div>
    <LoginSubmitButton loading={loading} label={submitLabel} disabled={!password} />
    <div className="flex w-full max-w-sm items-center">
      <div className="h-px flex-grow bg-slate-2"></div>
      <p className="px-4">Or</p>
      <div className="h-px flex-grow bg-slate-2"></div>
    </div>
    <div className="w-full">
      <Button
        appearance="reverse"
        onClick={onSignInWithCode}
        disabled={signInWithCodeLoading}
        className="min-w-[160px] w-full text-base normal-case"
      >
        {signInWithCodeLoading ? 'Sending code…' : 'Sign in with code instead'}
      </Button>
    </div>
  </form>
);

export default LoginPasswordStep;